// 📁 usersSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'users',
  initialState: {
    currentUser: null,
    userInitialized: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setUserInitialized: (state, action) => { 
      state.userInitialized = action.payload;
    },
  },
});

export const { setUser, setUserInitialized } = userSlice.actions;
export const selectUsers = (state) => state.users;
export default userSlice.reducer;